import * as React from 'react';
import * as api from '../../api';
import { CancelAppointmentListView } from './CancelAppointmentListView';
import { ModalContainer } from '../../components/ModalContainer';
import styles from './index.module.css';
import { useTranslation } from 'react-i18next';

interface Props {
  appointments: api.NotificationIntent.Appointment[];
  isOpen: boolean;
  onModalClose: () => void;
  onCancelAppointments: (encounterIds: string[]) => void;
  pending?: boolean;
}

export const CancelAppointmentModal: React.FC<Props> = ({
  isOpen,
  onModalClose,
  appointments,
  onCancelAppointments,
  pending,
}) => {
  const { t } = useTranslation();
  return (
    <ModalContainer
      isOpen={isOpen}
      onModalClose={onModalClose}
      contentClassName={styles.MaxWidth}
      childrenContainerClassName={styles.CancelAppointmentListContainer}
      topLabel={t('Cancel Appointment')}
    >
      <CancelAppointmentListView
        appointments={appointments}
        onCancelAppointments={onCancelAppointments}
        pending={pending}
      />
    </ModalContainer>
  );
};
